import type { Lineup, TournamentState } from "../../../../engine/types";

/** ?demo=courts3|courts2 on the wall or a tablet: how many courts the pretend switch leaves, or null. */
export function demoCourtsFromLocation(): number | null {
  const d = new URLSearchParams(location.search).get("demo");
  return d === "courts3" ? 3 : d === "courts2" ? 2 : null;
}

/** The day as it looks with only courts 1 to `n` in use: the other courts' games are gone and their players rest. */
export function demoCourts(s: TournamentState, n: number): TournamentState {
  const cut = (l: Lineup): Lineup => ({
    ...l,
    courts: l.courts.filter((c) => c.court <= n),
    sittingOut: [...l.sittingOut, ...l.courts.filter((c) => c.court > n).flatMap((c) => [...c.a, ...c.b])],
  });
  return {
    ...s,
    config: { ...s.config, courts: n },
    draft: s.draft ? cut(s.draft) : null,
    rounds: s.rounds.map((r) => ({ ...r, lineup: cut(r.lineup), games: r.games.filter((g) => g.court <= n) })),
  };
}
